module.exports = global["surveylab_page_likertSlider"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./likert-slider.ts");